export default __webpack_public_path__ + "static/media/exportar.9b5b4dc6.png";